module.exports = __webpack_public_path__ + "img/modulo_Icons.04980d3.svg";